import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {
    apply: {},
  },


  mutations: {

    setApply(state, apply) {
      state.apply = apply
    },

  },

  actions: {
    async apply({ commit }, orderId) {
      const data = await actionClient.post(`pay-apply/${orderId}`)
      commit('setApply', data)
    }
  }


}
